export default {
  'hero.title': 'Powering Growth through Technology and Strategic Investment',
  'hero.subtitle': 'Flexy Group is a dynamic technology company specializing in cutting-edge digital payment solutions, sophisticated banking software, and strategic tech investments that drive industry transformation.',
  'hero.exploreSolutions': 'Explore Our Solutions',
  'hero.investmentPortfolio': 'Investment Portfolio',
};
